import type { FC } from "react";

import type { LikedType } from "@/src/contexts";
import type { QueryXsMax } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import Share from "./Share";
import type { IShare } from "./ShareDefinitions";
import FavoriteLink from "./links/FavoriteLink";
import type { ILikeLink } from "./links/LikeLink";
import LikeLink from "./links/LikeLink";

import * as portalCss from "../shared/Portal.module.css";
import * as css from "./ActionButtonBanner.module.css";

export interface IActionButtonBanner {
    id: string;
    saveLink: boolean;
    saveLinkType: LikedType;
    share: IShare;
    like?: ILikeLink;
    isDiscountSaved?: boolean;
}

export const ActionButtonBanner: FC<IActionButtonBanner> = (props) => (
    <div className={`${css.actionButtonBannerComponent} ${portalCss.standardContainer}`}>
        <div className={css.actionsContainer}>
            {props.share && <Share {...props.share} appearance="default" iconStyleX={styles.shareIcon} />}
            {props.saveLink && (
                <FavoriteLink
                    id={props.id}
                    type={props.saveLinkType}
                    favoriteLinkIconSize="big"
                    showText={false}
                />
            )}
            {props.like && (
                <LikeLink {...props.like} styleX={styles.likeLink} textStyleX={styles.likeLinkText} />
            )}
        </div>
    </div>
);

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    likeLink: {
        bottom: 20,

        height: 30,
        lineHeight: 30,
        margin: 0,
        position: "absolute",
        transform: "translateX(-100%)",
        zIndex: 6,
    },

    likeLinkText: {
        fontSize: "1rem",
    },

    shareIcon: {
        height: { default: 35, [xsMax]: 22 },
        verticalAlign: "middle",
        width: { default: 35, [xsMax]: 22 },
    },
});
